<div class="min-h-screen bg-gray-50 py-8">
  <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
    
    <!-- Header -->
    <div class="bg-white shadow rounded-lg mb-6">
      <div class="px-6 py-4 border-b border-gray-200">
        <div class="flex items-center space-x-4">
          <div class="flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-blue-500 to-blue-600 text-white text-lg font-semibold shadow-lg">
            {{ currentUser?.firstName?.charAt(0) || 'U' }}{{ currentUser?.lastName?.charAt(0) || '' }}
          </div>
          <div>
            <h1 class="text-2xl font-bold text-gray-900">Mi Perfil</h1>
            <p class="text-sm text-gray-600">{{ currentUser?.email }}</p>
          </div>
        </div>
      </div>
      
      <!-- Tabs -->
      <div class="px-6">
        <nav class="flex space-x-8" aria-label="Tabs">
          <button 
            (click)="setActiveTab('profile')"
            [class]="activeTab === 'profile' 
              ? 'border-blue-500 text-blue-600 py-4 px-1 border-b-2 font-medium text-sm'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 py-4 px-1 border-b-2 font-medium text-sm'"
            type="button">
            <div class="flex items-center space-x-2">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              <span>Información Personal</span>
            </div>
          </button>
          
          <button 
            (click)="setActiveTab('password')"
            [class]="activeTab === 'password' 
              ? 'border-blue-500 text-blue-600 py-4 px-1 border-b-2 font-medium text-sm'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 py-4 px-1 border-b-2 font-medium text-sm'"
            type="button">
            <div class="flex items-center space-x-2">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 7a2 2 0 012 2m-2-2a2 2 0 00-2 2m2-2h2a2 2 0 012 2v6a2 2 0 01-2 2H9a2 2 0 01-2-2V9a2 2 0 012-2h2m2-2V5a2 2 0 00-2-2H9a2 2 0 00-2 2v2m6 0V5a2 2 0 00-2-2H9a2 2 0 00-2 2v2" />
              </svg>
              <span>Cambiar Contraseña</span>
            </div>
          </button>
        </nav>
      </div>
    </div>

    <!-- Content -->
    <div class="bg-white shadow rounded-lg">
      
      <!-- Tab: Información Personal -->
      <div *ngIf="activeTab === 'profile'" class="p-6">
        <form [formGroup]="profileForm" (ngSubmit)="onSubmitProfile()">
          <div class="space-y-6">
            
            <div class="flex items-center justify-between">
              <div>
                <h2 class="text-lg font-medium text-gray-900">Información Personal</h2>
                <p class="text-sm text-gray-600">Actualiza tu información básica.</p>
              </div>
              <div class="text-sm text-gray-500">
                * Campos requeridos
              </div>
            </div>

            <!-- Email (Solo lectura) -->
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-2">
                Correo Electrónico
              </label>
              <div class="relative">
                <input 
                  type="email" 
                  [value]="currentUser?.email || ''"
                  readonly
                  class="block w-full px-4 py-3 border border-gray-300 rounded-xl text-gray-900 bg-gray-50 cursor-not-allowed sm:text-sm">
                <div class="absolute inset-y-0 right-0 pr-3 flex items-center">
                  <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                  </svg>
                </div>
              </div>
              <p class="mt-1 text-xs text-gray-500">El correo electrónico no se puede modificar.</p>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              
              <!-- Nombre -->
              <div>
                <label for="firstName" class="block text-sm font-semibold text-gray-700 mb-2">
                  Nombre <span class="text-red-500">*</span>
                </label>
                <input 
                  type="text" 
                  id="firstName"
                  formControlName="firstName"
                  [class]="'block w-full px-4 py-3 border rounded-xl text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 transition duration-150 ease-in-out sm:text-sm ' +
                    (hasFieldError('firstName', 'profile') 
                      ? 'border-red-300 focus:ring-red-500 focus:border-red-500' 
                      : firstName?.valid && firstName?.touched 
                        ? 'border-green-300 focus:ring-green-500 focus:border-green-500' 
                        : 'border-gray-300 focus:ring-blue-500 focus:border-blue-500')"
                  placeholder="Tu nombre">
                <div *ngIf="hasFieldError('firstName', 'profile')" class="mt-1 text-sm text-red-600">
                  {{ getFieldError('firstName', 'profile') }}
                </div>
              </div>

              <!-- Apellido -->
              <div>
                <label for="lastName" class="block text-sm font-semibold text-gray-700 mb-2">
                  Apellido <span class="text-red-500">*</span>
                </label>
                <input 
                  type="text" 
                  id="lastName"
                  formControlName="lastName"
                  [class]="'block w-full px-4 py-3 border rounded-xl text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 transition duration-150 ease-in-out sm:text-sm ' +
                    (hasFieldError('lastName', 'profile') 
                      ? 'border-red-300 focus:ring-red-500 focus:border-red-500' 
                      : lastName?.valid && lastName?.touched 
                        ? 'border-green-300 focus:ring-green-500 focus:border-green-500' 
                        : 'border-gray-300 focus:ring-blue-500 focus:border-blue-500')"
                  placeholder="Tu apellido">
                <div *ngIf="hasFieldError('lastName', 'profile')" class="mt-1 text-sm text-red-600">
                  {{ getFieldError('lastName', 'profile') }}
                </div>
              </div>
              
            </div>

            <!-- Botones -->
            <div class="flex justify-end space-x-3 pt-6 border-t border-gray-200">
              <button 
                type="button"
                (click)="resetProfileForm()"
                class="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-150 ease-in-out">
                Cancelar
              </button>
              <button 
                type="submit" 
                [disabled]="!profileForm.valid || isLoadingProfile"
                class="px-6 py-2 border border-transparent text-sm font-medium rounded-lg text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition duration-150 ease-in-out">
                <span *ngIf="!isLoadingProfile" class="flex items-center">
                  <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                  </svg>
                  Guardar Cambios
                </span>
                <span *ngIf="isLoadingProfile" class="flex items-center">
                  <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Guardando...
                </span>
              </button>
            </div>
            
          </div>
        </form>
      </div>

      <!-- Tab: Cambiar Contraseña -->
      <div *ngIf="activeTab === 'password'" class="p-6">
        <form [formGroup]="passwordForm" (ngSubmit)="onSubmitPassword()">
          <div class="space-y-6">
            
            <div class="flex items-center justify-between">
              <div>
                <h2 class="text-lg font-medium text-gray-900">Cambiar Contraseña</h2>
                <p class="text-sm text-gray-600">Actualiza tu contraseña para mantener tu cuenta segura.</p>
              </div>
              <div class="text-sm text-gray-500">
                * Campos requeridos
              </div>
            </div>

            <!-- Contraseña Actual -->
            <div>
              <label for="currentPassword" class="block text-sm font-semibold text-gray-700 mb-2">
                Contraseña Actual <span class="text-red-500">*</span>
              </label>
              <div class="relative">
                <input 
                  [type]="showCurrentPassword ? 'text' : 'password'" 
                  id="currentPassword"
                  formControlName="currentPassword"
                  [class]="'block w-full pl-4 pr-12 py-3 border rounded-xl text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 transition duration-150 ease-in-out sm:text-sm ' +
                    (hasFieldError('currentPassword', 'password') 
                      ? 'border-red-300 focus:ring-red-500 focus:border-red-500' 
                      : 'border-gray-300 focus:ring-blue-500 focus:border-blue-500')"
                  placeholder="Tu contraseña actual">
                <div class="absolute inset-y-0 right-0 pr-3 flex items-center">
                  <button 
                    type="button" 
                    (click)="togglePasswordVisibility('current')"
                    class="text-gray-400 hover:text-gray-600 focus:outline-none focus:text-gray-600 transition duration-150 ease-in-out"
                    tabindex="-1">
                    <svg *ngIf="!showCurrentPassword" class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                    </svg>
                    <svg *ngIf="showCurrentPassword" class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21" />
                    </svg>
                  </button>
                </div>
              </div>
              <div *ngIf="hasFieldError('currentPassword', 'password')" class="mt-1 text-sm text-red-600">
                {{ getFieldError('currentPassword', 'password') }}
              </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              
              <!-- Nueva Contraseña -->
              <div>
                <label for="newPassword" class="block text-sm font-semibold text-gray-700 mb-2">
                  Nueva Contraseña <span class="text-red-500">*</span>
                </label>
                <div class="relative">
                  <input 
                    [type]="showNewPassword ? 'text' : 'password'" 
                    id="newPassword"
                    formControlName="newPassword"
                    [class]="'block w-full pl-4 pr-12 py-3 border rounded-xl text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 transition duration-150 ease-in-out sm:text-sm ' +
                      (hasFieldError('newPassword', 'password') 
                        ? 'border-red-300 focus:ring-red-500 focus:border-red-500' 
                        : newPassword?.valid && newPassword?.touched 
                          ? 'border-green-300 focus:ring-green-500 focus:border-green-500' 
                          : 'border-gray-300 focus:ring-blue-500 focus:border-blue-500')"
                    placeholder="Nueva contraseña">
                  <div class="absolute inset-y-0 right-0 pr-3 flex items-center">
                    <button 
                      type="button" 
                      (click)="togglePasswordVisibility('new')"
                      class="text-gray-400 hover:text-gray-600 focus:outline-none focus:text-gray-600 transition duration-150 ease-in-out"
                      tabindex="-1">
                      <svg *ngIf="!showNewPassword" class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                      </svg>
                      <svg *ngIf="showNewPassword" class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21" />
                      </svg>
                    </button>
                  </div>
                </div>
                <div *ngIf="hasFieldError('newPassword', 'password')" class="mt-1 text-sm text-red-600">
                  {{ getFieldError('newPassword', 'password') }}
                </div>
                <div class="mt-1 text-xs text-gray-500">
                  <p class="font-medium mb-1">La contraseña debe cumplir:</p>
                  <ul class="list-disc list-inside space-y-0.5">
                    <li>Mínimo 6 caracteres</li>
                    <li>Al menos una letra mayúscula (A-Z)</li>
                    <li>Al menos un carácter especial (!&#64;#$%^&*)</li>
                  </ul>
                </div>
              </div>

              <!-- Confirmar Nueva Contraseña -->
              <div>
                <label for="confirmNewPassword" class="block text-sm font-semibold text-gray-700 mb-2">
                  Confirmar Nueva Contraseña <span class="text-red-500">*</span>
                </label>
                <div class="relative">
                  <input 
                    [type]="showConfirmPassword ? 'text' : 'password'" 
                    id="confirmNewPassword"
                    formControlName="confirmNewPassword"
                    [class]="'block w-full pl-4 pr-12 py-3 border rounded-xl text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 transition duration-150 ease-in-out sm:text-sm ' +
                      (hasFieldError('confirmNewPassword', 'password') 
                        ? 'border-red-300 focus:ring-red-500 focus:border-red-500' 
                        : confirmNewPassword?.valid && confirmNewPassword?.touched 
                          ? 'border-green-300 focus:ring-green-500 focus:border-green-500' 
                          : 'border-gray-300 focus:ring-blue-500 focus:border-blue-500')"
                    placeholder="Confirma tu nueva contraseña">
                  <div class="absolute inset-y-0 right-0 pr-3 flex items-center">
                    <button 
                      type="button" 
                      (click)="togglePasswordVisibility('confirm')"
                      class="text-gray-400 hover:text-gray-600 focus:outline-none focus:text-gray-600 transition duration-150 ease-in-out"
                      tabindex="-1">
                      <svg *ngIf="!showConfirmPassword" class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                      </svg>
                      <svg *ngIf="showConfirmPassword" class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21" />
                      </svg>
                    </button>
                  </div>
                </div>
                <div *ngIf="hasFieldError('confirmNewPassword', 'password')" class="mt-1 text-sm text-red-600">
                  {{ getFieldError('confirmNewPassword', 'password') }}
                </div>
              </div>
              
            </div>

            <!-- Botones -->
            <div class="flex justify-end space-x-3 pt-6 border-t border-gray-200">
              <button 
                type="button"
                (click)="resetPasswordForm()"
                class="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-150 ease-in-out">
                Cancelar
              </button>
              <button 
                type="submit" 
                [disabled]="!passwordForm.valid || isLoadingPassword"
                class="px-6 py-2 border border-transparent text-sm font-medium rounded-lg text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition duration-150 ease-in-out">
                <span *ngIf="!isLoadingPassword" class="flex items-center">                  
                  Cambiar Contraseña
                </span>
                <span *ngIf="isLoadingPassword" class="flex items-center">
                  <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Cambiando...
                </span>
              </button>
            </div>
            
          </div>
        </form>
      </div>
      
    </div>
    
  </div>
</div>
